import React, { useContext, useState } from 'react';
import { Field } from 'redux-form';
import gisAPI, { cancelRequest } from '../../../_api/gis';
import { renderField } from './FormsControls.jsx';
import { LangContext } from '../../App.jsx';

function LivingPlaceAutocomplete({ label, autoFocus, helptext, placeholder, simple, onBlur, inputRef }) {
  const lang = useContext(LangContext);
  const useAutocomplete = ['ru', 'en'].includes(lang);
  let [suggestions, setSuggestions] = useState([]);

  const handleChange = (value) => {
    if (value && value.length > 3) {
      try {
        if (cancelRequest !== undefined) cancelRequest();
        gisAPI.getGisSuggestions(value).then(response => {
          if (response) setSuggestions(response);
        });
      }
      catch (e) {}
      finally {}
    }
  };

  let inputField = '';
  if (useAutocomplete) {
    inputField = <Field label={ label }
                        placeholder={ placeholder }
                        helptext={ helptext }
                        component={ renderField }
                        onChange={ handleChange }
                        autoFocus={ autoFocus }
                        suggestions={ suggestions }
                        element='autocomplete'
                        name='living_place'
                        onBlur={ onBlur }
                        simple={ simple }
                        inputRef={ inputRef }/>
  } else {
    inputField = <Field label={ label }
                        placeholder={ placeholder }
                        helptext={ helptext }
                        component={ renderField }
                        name='living_place'
                        simple={ simple }
                        onBlur={ onBlur }
                        inputRef={ inputRef }/>
  }

  return inputField;
}

export default LivingPlaceAutocomplete;
